export const LIENS_SHARE_TABLE_CHANGE = 'LIENS_SHARE_TABLE_CHANGE'
export const LIENS_SHARE_TABLE_CHANGE_REQUEST = (id) => `LIENS_${id}_SHARE_TABLE_CHANGE_REQUEST`
export const LIENS_SHARE_TABLE_LOADING_TRUE = 'LIENS_SHARE_TABLE_LOADING_TRUE'
export const LIENS_SHARE_TABLE_LOADING_FALSE = 'LIENS_SHARE_TABLE_LOADING_FALSE'
export const LIENS_SHARE_TABLE_DATA_RECEIVED = 'LIENS_SHARE_TABLE_DATA_RECEIVED'
